import { SyntheticEvent, useState } from "react";
import styled from "styled-components";

interface ImageContainerProps {
  width?: string;
  height?: string;
  backgroundColor?: string;
}

const ImageContainer = styled.div<ImageContainerProps>`
  width: ${(props) => props.width || "40px"};
  height: ${(props) => props.height || "40px"};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: ${(props) =>
    props.backgroundColor ||
    ""}; /* Optional: Background color of the container */
`;

const StyledImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

interface SntImageViewProps {
  src?: string;
  alt?: string;
  width?: string;
  height?: string;
  size?: string | number;
}

const SntImageView = ({
  src,
  alt = "",
  width = "40px",
  height = "40px",
  size,
}: SntImageViewProps) => {
  const [isSquare, setIsSquare] = useState(false);

  const handleImageLoad = (event: SyntheticEvent<HTMLImageElement>) => {
    const { naturalWidth, naturalHeight } = event.currentTarget;
    if (naturalWidth === naturalHeight) {
      setIsSquare(true);
    } else {
      setIsSquare(false);
    }
  };

  return (
    <>
      <ImageContainer width={width} height={height}>
        <StyledImage
          src={
            size != undefined
              ? src == undefined
                ? ""
                : src + (src.indexOf("?") < 0 ? "?size=" : "&size=") + size
              : src
          }
          alt={alt}
          onLoad={handleImageLoad}
          width={isSquare ? width : undefined}
          height={isSquare ? height : undefined}
        />
      </ImageContainer>
    </>
  );
};

export default SntImageView;
